import { state } from "@wb/ui/analytics/state";
import { z } from "zod";

export type Track = (
  eventName: string,
  properties?: Record<string, any>,
) => void;

const eventNameSchema = z.custom<string>((value) => {
  if (typeof value !== "string") {
    throw new Error("Event name must be a string");
  }

  if (value.length === 0) {
    throw new Error("Event name must be at least 1 character long");
  }

  // if (value !== snakeCase(value)) {
  //   throw new Error("Event name must be in snake_case");
  // }

  return value;
});

/**
 * Track an event
 *
 * @example
 *
 * <button
 *  onClick={() => track("button_click", { type: "upload" })}
 * >
 *  Click me
 * </button>
 *
 * @param eventName - The name of the event to track
 * @param properties - Optional properties to track with the event
 */
export const track: Track = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  const { instances, debug } = state;

  const { success, error } = eventNameSchema.safeParse(eventName);

  if (!success) {
    console.error("Invalid event name: ", eventName);
    console.error(error);
    return;
  }

  if (debug) {
    console.log("Tracking: ", eventName, properties);
  }

  instances.map((instance) => {
    instance.track(eventName, properties);
  });
};
